import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { SuiClientProvider, WalletProvider } from '@mysten/dapp-kit';
import { initSentry } from './sentry';
import { SUI_NETWORK, SUI_RPC_URL } from './services/sui-client';
import App from './App';
import './index.css';

initSentry();

// Create a query client
const queryClient = new QueryClient();

// Use the shared Sui client config (supports Shinami when API key is set)
const networks = {
  [SUI_NETWORK]: { url: SUI_RPC_URL },
};

const defaultNetwork = SUI_NETWORK;

// Render the app
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <SuiClientProvider networks={networks} defaultNetwork={defaultNetwork}>
          <WalletProvider autoConnect>
            <App />
          </WalletProvider>
        </SuiClientProvider>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
